import { Link } from 'react-router-dom';

const categories = [
  {
    type: 'movie',
    label: '电影',
    desc: '院线大片 · 高分佳作',
    count: '8 部精选',
    icon: 'ri-film-line',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20image%20of%20a%20grand%20movie%20theater%20with%20warm%20amber%20stage%20lights%20and%20deep%20velvet%20seats%2C%20atmospheric%20moody%20dark%20tones%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hs-cat1&orientation=landscape',
  },
  {
    type: 'tv',
    label: '电视剧',
    desc: '热播剧集 · 追更不停',
    count: '8 部精选',
    icon: 'ri-tv-2-line',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20image%20of%20a%20cozy%20living%20room%20at%20night%20with%20a%20glowing%20screen%20and%20warm%20amber%20ambient%20lamp%20light%2C%20deep%20charcoal%20shadows%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hs-cat2&orientation=landscape',
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '真人秀 · 音乐美食',
    count: '8 档精选',
    icon: 'ri-mic-line',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20image%20of%20a%20vibrant%20stage%20with%20warm%20amber%20spotlights%20and%20haze%20beams%2C%20deep%20charcoal%20background%2C%20energetic%20atmosphere%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hs-cat3&orientation=landscape',
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
      {categories.map((cat) => (
        <Link
          key={cat.type}
          to={`/category/${cat.type}`}
          className="group relative block h-44 cursor-pointer overflow-hidden rounded-lg md:h-52"
        >
          <img
            src={cat.image}
            alt={`${cat.label}分类`}
            title={`${cat.label} - 黄色影视`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/40 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-5">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">{cat.label}</span>
              </div>
              <p className="mt-2 text-xs text-foreground-600">{cat.desc}</p>
            </div>
            <span className="text-xs text-accent-400">{cat.count}</span>
          </div>
        </Link>
      ))}
    </div>
  );
}